const initializeProductRecommendations = (scope = document) => {
  scope
    .querySelectorAll('[data-product-recommendations]:not([data-recommendations-loaded])')
    .forEach(async (container) => {
      container.dataset.recommendationsLoaded = 'true';
      const url = container.dataset.recommendationsUrl;
      if (!url) return;

      try {
        const response = await fetch(url, {
          headers: { Accept: 'text/html' },
        });
        if (!response.ok) throw new Error();

        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const recommendations = html.querySelector('[data-product-recommendations]');

        if (recommendations?.innerHTML.trim()) {
          container.innerHTML = recommendations.innerHTML;
        }
      } catch {
        container.remove();
      }
    });
};

initializeProductRecommendations();

document.addEventListener('shopify:section:load', (event) => {
  initializeProductRecommendations(event.target);
});
